<template>
  <div class="p-box">
    <div class="p-box__body">
      <p>{{ $t('pages.CompaniesStorePost.selectedStores') }}：<span class="select-store">{{ selectStoresLength }}</span></p>

      <div class="c-button c-button--icon">
        <button
          class="c-button__item c-button__item--primary"
          type="button"
          @click="$emit('open-store-modal')"
        >
          <img class="c-button__icon" :src="imgIconPlusRed" alt="">

          {{ $t('pages.CompaniesStorePost.selectStores') }}
        </button>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import ImgIconPlusRed from '../../../images/common/icon_plus_red.svg'
import { i18n } from '../plugins/i18n'

export default {
  name: 'SelectStore',
  props: {
    selectedStoreCount: Number,
  },
  emits: ['open-store-modal'],
  computed: {
    imgIconPlusRed() {
      return ImgIconPlusRed
    },
    selectStoresLength() {
      return this.selectedStoreCount != 0 ?
        i18n.t('pages.CompaniesStorePost.selectStoresCount', { count: this.selectedStoreCount }) :
        i18n.t('messages.notSelected')
    },
  }
}
</script>

<style lang="scss" scoped>
.select-store {
  font-weight: bold;
}
</style>
